import React, { SVGProps } from 'react';

type PublicSessionLoginContinueProps = SVGProps<SVGSVGElement>;

export function PublicSessionLoginContinue({ ...props }: PublicSessionLoginContinueProps): JSX.Element {
  return (
    <svg width='221' height='235' viewBox='0 0 221 235' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g id='Illustration Container'>
        <g id='Group 2'>
          <path
            id='Vector'
            opacity='0.08'
            d='M220 110C220 170.751 170.751 220 110 220C49.2487 220 0 170.751 0 110C0 49.2487 49.2487 0 110 0C170.751 0 220 49.2487 220 110Z'
            fill='#8DA1B4'
          />
          <path
            id='Vector_2'
            opacity='0.1'
            d='M198.289 110C198.289 158.761 158.761 198.289 110 198.289C61.239 198.289 21.7104 158.761 21.7104 110C21.7104 61.2391 61.239 21.7105 110 21.7105C158.761 21.7105 198.289 61.2391 198.289 110Z'
            fill='#446583'
          />
          <g id='Group' filter='url(#filter0_d_3268_111288)'>
            <path
              id='Vector_3'
              d='M59.8574 29.6729C59.8574 21.5693 66.4267 15 74.5303 15H146.427C154.531 15 161.1 21.5693 161.1 29.6729V191.467C161.1 199.57 154.531 206.14 146.427 206.14H74.5303C66.4267 206.14 59.8574 199.57 59.8574 191.467V29.6729Z'
              fill='white'
            />
          </g>
          <g id='Group_2' filter='url(#filter1_d_3268_111288)'>
            <path
              id='Vector_4'
              d='M146.427 204.568V206.14H74.5302V204.568H146.427ZM159.529 191.467V29.6729C159.529 22.4372 153.663 16.5714 146.427 16.5713H74.5302C67.2945 16.5713 61.4287 22.4371 61.4287 29.6729V191.467C61.4287 198.702 67.2945 204.568 74.5302 204.568V206.14L74.1513 206.135C66.3488 205.937 60.0601 199.648 59.8623 191.846L59.8574 191.467V29.6729C59.8574 21.6959 66.2229 15.2059 74.1513 15.0049L74.5302 15H146.427L146.806 15.0049C154.735 15.206 161.1 21.696 161.1 29.6729V191.467L161.095 191.846C160.898 199.648 154.609 205.937 146.806 206.135L146.427 206.14V204.568C153.663 204.568 159.529 198.702 159.529 191.467Z'
              fill='#A0A8AB'
            />
          </g>
          <path
            id='Vector_5'
            d='M131.857 18.0177C131.857 21.8739 128.731 25 124.875 25H94.8396C90.9834 25 87.8574 21.8739 87.8574 18.0177V15H131.857V18.0177Z'
            fill='#F2F3F4'
          />
          <path
            id='Vector_6'
            d='M89.4287 18.0176C89.4287 21.0059 91.8515 23.4287 94.8398 23.4287H124.875C127.863 23.4287 130.286 21.0059 130.286 18.0176V16.5713H89.4287V18.0176ZM87.8574 15H131.857V18.0176C131.857 21.7533 128.923 24.8043 125.234 24.9912L124.875 25H94.8398L94.4804 24.9912C90.7912 24.8042 87.8574 21.7533 87.8574 18.0176V15Z'
            fill='#A0A8AB'
          />
          <path
            id='Vector_7'
            d='M149.781 79.519C149.781 78.2173 148.726 77.1625 147.424 77.1625H74.3525C73.0509 77.1627 71.9962 78.2174 71.996 79.519V88.1625C71.9962 89.4641 73.0509 90.5188 74.3525 90.519H147.424C148.726 90.519 149.781 89.4642 149.781 88.1625V79.519ZM151.353 88.1625C151.352 90.332 149.594 92.0903 147.424 92.0903H74.3525C72.183 92.0901 70.424 90.3319 70.4238 88.1625V79.519C70.4239 77.3495 72.183 75.5904 74.3525 75.5903H147.424C149.594 75.5903 151.353 77.3494 151.353 79.519V88.1625Z'
            fill='#8DA1B4'
          />
          <path
            id='Vector_8'
            d='M149.781 100.733C149.781 99.4316 148.726 98.3768 147.424 98.3768H74.3525C73.0509 98.377 71.9962 99.4317 71.996 100.733V109.377C71.9962 110.678 73.0509 111.733 74.3525 111.733H147.424C148.726 111.733 149.781 110.678 149.781 109.377V100.733ZM151.353 109.377C151.352 111.546 149.594 113.305 147.424 113.305H74.3525C72.183 113.304 70.424 111.546 70.4238 109.377V100.733C70.4239 98.5638 72.183 96.8047 74.3525 96.8046H147.424C149.594 96.8046 151.353 98.5637 151.353 100.733V109.377Z'
            fill='#8DA1B4'
          />
          <path
            id='Vector_9'
            d='M121.941 50.3765C121.941 44.0253 116.793 38.8765 110.441 38.8765C104.09 38.8765 98.9414 44.0253 98.9414 50.3765C98.9414 56.7278 104.09 61.8765 110.441 61.8765C116.793 61.8765 121.941 56.7278 121.941 50.3765Z'
            fill='#EDF1FA'
          />
          <path
            id='Vector_10'
            d='M121.941 50.3765C121.941 44.0253 116.793 38.8765 110.441 38.8765C104.09 38.8765 98.9414 44.0253 98.9414 50.3765C98.9414 56.7278 104.09 61.8765 110.441 61.8765C116.793 61.8765 121.941 56.7278 121.941 50.3765Z'
            stroke='#C1D3F1'
          />
          <path
            id='Vector_11'
            d='M111.563 56.0147L111.012 56.2265C110.828 56.2971 110.635 56.3324 110.442 56.3324V44.4206C112.059 44.4056 113.662 44.7323 115.144 45.3794C115.282 45.4425 115.399 45.5441 115.48 45.6721C115.562 45.8 115.605 45.9487 115.604 46.1004V50.1314C115.604 51.4055 115.217 52.6497 114.496 53.6999C113.775 54.7502 112.752 55.5573 111.563 56.0147Z'
            fill='#C1D3F1'
          />
          <path
            id='Vector_12'
            d='M115.103 46.0969L115.093 46.0158C115.085 45.9894 115.073 45.964 115.058 45.9406C115.029 45.8948 114.987 45.8582 114.938 45.8351C113.522 45.2179 111.991 44.9058 110.446 44.9201L110.437 44.9211C108.893 44.9068 107.364 45.2177 105.948 45.8342L105.879 45.8781C105.858 45.8961 105.84 45.9172 105.825 45.9406C105.795 45.9872 105.78 46.0416 105.78 46.0969V50.131L105.784 50.3508C105.825 51.4468 106.177 52.5106 106.8 53.4172C107.464 54.384 108.405 55.1269 109.5 55.548L110.051 55.7599L110.146 55.7912C110.372 55.8548 110.613 55.8446 110.833 55.7599L111.384 55.548L111.587 55.465C112.595 55.0329 113.461 54.3236 114.084 53.4172C114.748 52.4502 115.103 51.3041 115.103 50.131V46.0969ZM116.098 50.3889C116.05 51.6736 115.638 52.9199 114.908 53.9826C114.178 55.0453 113.163 55.8773 111.981 56.384L111.743 56.4816L111.191 56.6935C110.769 56.8558 110.308 56.8757 109.876 56.7541L109.692 56.6935L109.141 56.4816C107.858 55.9879 106.754 55.1162 105.975 53.9826C105.246 52.9199 104.834 51.6735 104.785 50.3889L104.78 50.131V46.1008C104.779 45.8538 104.849 45.6118 104.982 45.4035C105.115 45.1945 105.306 45.0282 105.531 44.925L105.54 44.9211L105.831 44.798C107.293 44.2054 108.858 43.9086 110.437 43.9221C110.439 43.9221 110.44 43.9221 110.441 43.9221C110.443 43.9221 110.444 43.9211 110.446 43.9211L110.445 43.9221C112.025 43.9084 113.59 44.2053 115.053 44.798L115.344 44.9211L115.352 44.925L115.514 45.0139C115.669 45.114 115.802 45.2466 115.902 45.4035C116.035 45.6118 116.104 45.8539 116.103 46.1008V50.131L116.098 50.3889Z'
            fill='#0075E0'
          />
          <path
            id='Vector_13'
            d='M112.765 50.2318V47.8519C112.031 47.5112 111.242 47.3391 110.447 47.347H110.437C109.629 47.3389 108.827 47.516 108.083 47.8676C107.834 47.9856 107.535 47.8789 107.417 47.6293C107.299 47.3796 107.406 47.0813 107.656 46.9633C108.531 46.5494 109.479 46.3399 110.437 46.348C110.438 46.348 110.439 46.348 110.441 46.348C110.443 46.348 110.445 46.347 110.447 46.347L110.446 46.348C111.284 46.3408 112.114 46.5005 112.895 46.8177L113.228 46.9633L113.236 46.9672L113.355 47.0375C113.43 47.0899 113.496 47.1533 113.552 47.224L113.628 47.3353L113.689 47.4554C113.74 47.5783 113.765 47.7105 113.765 47.8431V50.2318L113.754 50.5482C113.703 51.2844 113.472 51.9973 113.081 52.6136C112.69 53.2304 112.153 53.7273 111.523 54.0511L111.247 54.1791L110.946 54.3051L110.849 54.3344C110.621 54.3789 110.385 54.2584 110.292 54.0355C110.186 53.7806 110.307 53.4873 110.562 53.3812L110.863 53.2562L111.066 53.1615C111.532 52.9221 111.937 52.5507 112.237 52.0785C112.536 51.6058 112.716 51.0534 112.756 50.4789L112.765 50.2318Z'
            fill='#0075E0'
          />
          <path
            id='Vector_14'
            d='M154.879 121.376H65.0039C56.409 121.376 49.4414 128.344 49.4414 136.939C49.4414 145.533 56.409 152.501 65.0039 152.501H154.879C163.474 152.501 170.441 145.533 170.441 136.939C170.441 128.344 163.474 121.376 154.879 121.376Z'
            fill='white'
          />
          <path
            id='Vector_15'
            d='M154.879 121.376H65.0039C56.409 121.376 49.4414 128.344 49.4414 136.939C49.4414 145.533 56.409 152.501 65.0039 152.501H154.879C163.474 152.501 170.441 145.533 170.441 136.939C170.441 128.344 163.474 121.376 154.879 121.376Z'
            stroke='#8DA1B4'
            strokeWidth='1.57143'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_16'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M117.202 137.111C117.202 136.575 117.154 136.059 117.064 135.564H109.942V138.489H114.012C113.836 139.435 113.304 140.235 112.503 140.772V142.669H114.947C116.377 141.353 117.202 139.414 117.202 137.111Z'
            fill='#4285F4'
          />
          <path
            id='Vector_17'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M109.942 144.501C111.983 144.501 113.695 143.824 114.947 142.669L112.503 140.772C111.825 141.225 110.959 141.494 109.942 141.494C107.972 141.494 106.305 140.163 105.71 138.376H103.183V140.335C104.428 142.807 106.985 144.501 109.942 144.501Z'
            fill='#34A853'
          />
          <path
            id='Vector_18'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M105.71 138.376C105.559 137.922 105.473 137.438 105.473 136.939C105.473 136.441 105.559 135.956 105.71 135.502V133.543H103.184C102.671 134.564 102.379 135.719 102.379 136.939C102.379 138.159 102.671 139.314 103.184 140.335L105.71 138.376Z'
            fill='#FBBC05'
          />
          <path
            id='Vector_19'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M109.942 132.384C111.052 132.384 112.049 132.766 112.833 133.515L115.002 131.346C113.692 130.126 111.98 129.376 109.942 129.376C106.985 129.376 104.428 131.071 103.183 133.543L105.71 135.502C106.305 133.715 107.972 132.384 109.942 132.384Z'
            fill='#EA4335'
          />
          <path
            id='Vector_20'
            d='M154.879 156.501H65.0039C56.409 156.501 49.4414 163.469 49.4414 172.064C49.4414 180.658 56.409 187.626 65.0039 187.626H154.879C163.474 187.626 170.441 180.658 170.441 172.064C170.441 163.469 163.474 156.501 154.879 156.501Z'
            fill='white'
          />
          <path
            id='Vector_21'
            d='M154.879 156.501H65.0039C56.409 156.501 49.4414 163.469 49.4414 172.064C49.4414 180.658 56.409 187.626 65.0039 187.626H154.879C163.474 187.626 170.441 180.658 170.441 172.064C170.441 163.469 163.474 156.501 154.879 156.501Z'
            stroke='#8DA1B4'
            strokeWidth='1.57143'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <g id='Clip path group'>
            <mask
              id='mask0_3268_111288'
              style={{ maskType: 'luminance' }}
              maskUnits='userSpaceOnUse'
              x='102'
              y='164'
              width='16'
              height='16'
            >
              <g id='clip0_3268_111384'>
                <path id='Vector_22' d='M117.504 164.501H102.379V179.626H117.504V164.501Z' fill='white' />
              </g>
            </mask>
            <g mask='url(#mask0_3268_111288)'>
              <g id='Group_3'>
                <path
                  id='Vector_23'
                  d='M115.791 176.113C115.572 176.619 115.312 177.085 115.012 177.514C114.602 178.098 114.266 178.502 114.008 178.727C113.607 179.096 113.178 179.284 112.718 179.295C112.388 179.295 111.989 179.201 111.526 179.011C111.061 178.821 110.634 178.727 110.243 178.727C109.833 178.727 109.394 178.821 108.924 179.011C108.453 179.201 108.073 179.3 107.784 179.31C107.343 179.329 106.903 179.135 106.464 178.727C106.184 178.483 105.834 178.064 105.414 177.471C104.964 176.837 104.594 176.103 104.304 175.265C103.993 174.361 103.838 173.485 103.838 172.637C103.838 171.665 104.048 170.828 104.468 170.126C104.798 169.562 105.238 169.117 105.788 168.79C106.338 168.464 106.933 168.297 107.573 168.287C107.923 168.287 108.383 168.395 108.953 168.608C109.523 168.821 109.888 168.93 110.048 168.93C110.168 168.93 110.574 168.803 111.262 168.551C111.913 168.316 112.463 168.219 112.913 168.258C114.132 168.356 115.048 168.837 115.658 169.703C114.567 170.364 114.028 171.289 114.038 172.477C114.048 173.401 114.384 174.171 115.043 174.782C115.342 175.066 115.676 175.285 116.047 175.441C115.966 175.674 115.881 175.898 115.791 176.113ZM112.994 165.107C112.994 165.832 112.729 166.508 112.201 167.135C111.564 167.88 110.794 168.31 109.958 168.242C109.948 168.155 109.941 168.064 109.941 167.967C109.941 167.272 110.244 166.527 110.782 165.918C111.051 165.61 111.393 165.353 111.807 165.149C112.22 164.947 112.611 164.836 112.979 164.817C112.99 164.914 112.994 165.011 112.994 165.107Z'
                  fill='#2C3236'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <filter
          id='filter0_d_3268_111288'
          x='38.0378'
          y='0.162671'
          width='144.882'
          height='234.779'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='6.98227' />
          <feGaussianBlur stdDeviation='10.9098' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0.6 0 0 0 0 0.658824 0 0 0 0 0.733333 0 0 0 0.3 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_3268_111288' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_3268_111288' result='shape' />
        </filter>
        <filter
          id='filter1_d_3268_111288'
          x='38.0378'
          y='0.162671'
          width='144.882'
          height='234.779'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='6.98227' />
          <feGaussianBlur stdDeviation='10.9098' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0.6 0 0 0 0 0.658824 0 0 0 0 0.733333 0 0 0 0.3 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_3268_111288' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_3268_111288' result='shape' />
        </filter>
      </defs>
    </svg>
  );
}
